module.exports = __webpack_public_path__ + "img/Impact identification-Impact definition.45b3ae47.svg";